import * as React from 'react';

const TagFillSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 24 24" {...props}>
        <defs>
            <path
                id="tag-fill_svg__a"
                d="M10 0H0v10l10 10 10-10L10 0zM5 6.5c.827 0 1.5-.673 1.5-1.5S5.827 3.5 5 3.5 3.5 4.173 3.5 5 4.173 6.5 5 6.5z"
            />
        </defs>
        <g fill="none" fillRule="evenodd" transform="translate(2 2)">
            <mask id="tag-fill_svg__b" fill="#fff">
                <use xlinkHref="#tag-fill_svg__a" />
            </mask>
            <use fill="#45494E" xlinkHref="#tag-fill_svg__a" />
            <g mask="url(#tag-fill_svg__b)">
                <path fill="#000" d="M-2-2h24v24H-2z" />
            </g>
        </g>
    </svg>
);

TagFillSvg.displayName = 'TagFillSvg';
export default TagFillSvg;
